var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMotion = function SvgMotion(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4174",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4724",
    fill: "currentColor",
    d: "M17.334 0C16.595 0 16 .595 16 1.334v9.332c0 .739.595 1.334 1.334 1.334h5.332c.739 0 1.334-.595 1.334-1.334V1.334C24 .595 23.405 0 22.666 0zM20 7.5a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1",
    transform: "translate(0 1028.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4729",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 1043.9a9.5 9.5 0 0 1-7.537-3.717 9.5 9.5 0 0 1-1.64-8.242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4731",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 1047.4a13 13 0 0 1-10.314-5.086 13 13 0 0 1-2.243-11.279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse4138",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 1050.9a16.5 16.5 0 0 1-13.09-6.455 16.5 16.5 0 0 1-2.847-14.315"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMotion);
export default ForwardRef;